import { Box, Pagination } from "@mui/material";
import React from "react";

const PaginationControl = ({ pageCount, page, handlePageChange }) => {
  return (
    <Box display="flex" justifyContent="center" mt={4} mb={4}>
      <Pagination
        count={pageCount}
        page={page}
        onChange={handlePageChange}
        sx={{ color: "#686868" }}
      />
    </Box>
  );
};

export default PaginationControl;
